import React, { useEffect } from 'react';

export default function GalleryLightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  if (currentIndex === null || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  // Tastatur-navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onPrev, onNext]);

  // Forhindre scroll på baggrunden
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-choc-dark/95 backdrop-blur-sm p-4 sm:p-6 md:p-10 animate-in fade-in duration-200">
      {/* Luk knap */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 text-cream-light/80 hover:text-white text-3xl p-2 cursor-pointer z-50 transition-colors"
        aria-label="Luk visning"
      >
        <i className="fa-solid fa-xmark" />
      </button>

      {/* Forrige knap */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 sm:left-6 text-cream-light/80 hover:text-white text-3xl sm:text-4xl p-3 cursor-pointer z-50 transition-colors bg-black/20 hover:bg-black/40 rounded-full"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left" />
        </button>
      )}

      {/* Billede container */}
      <div className="relative max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
        <img
          src={currentImage}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl select-none animate-in zoom-in-95 duration-200"
        />
        {images.length > 1 && (
          <div className="mt-4 text-cream-light/60 text-sm font-sans">
            {currentIndex + 1} af {images.length}
          </div>
        )}
      </div>

      {/* Næste knap */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 sm:right-6 text-cream-light/80 hover:text-white text-3xl sm:text-4xl p-3 cursor-pointer z-50 transition-colors bg-black/20 hover:bg-black/40 rounded-full"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right" />
        </button>
      )}
    </div>
  );
}
